import React, { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import ProCon from "../img/pp.jpg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import ShowCv from "../Components/ShowCv";
import { Mobile } from "../Response";
const Contact = () => {
  const back = useSelector((state) => state.switch.back);
  const [showF, setShowF] = useState(false);
  const [showI, setShowI] = useState(false);
  const [showL, setShowL] = useState(false);
  const [showT, setShowT] = useState(false);
  const [Show_Cv, setShow_Cv] = useState(false);

  return (
    <Container>
      <Wrap back={back}>
        <Top>
          <ImagePro src={ProCon} />
        </Top>
        <Bottom>
          <TOPBOTTOM>
            <EachCon back={back}>
              <EmailOutlinedIcon className="ic" />
              <Links href="mailto: mariwanakrammohammed@gmail.com" back={back}>
              MariwanAkramMohammed@gmail.com
              </Links>
            </EachCon>
            <EachCon back={back}>
              <PinDropOutlinedIcon className="ic" />
              <Links back={back}>Sulaimany</Links>
            </EachCon>
            <EachCon back={back}>
              <CallOutlinedIcon className="ic" />
              <Links href="tel:07511828836" back={back}>
                +964 751 182 8836
              </Links>

              {/* <a href="tel:123-456-7890">123-456-7890</a> */}
            </EachCon>
          </TOPBOTTOM>
          <BottomBot>
            <Cons>
              <Icons back={back}>
                <FacebookIcon
                  className="icon"
                  onClick={() => {
                    setShowF(!showF);
                    setShowI(false);
                    setShowL(false);
                    setShowT(false);
                  }}
                />
                {showF && <IconsLink back={back}>Mariwan A-Mohammed</IconsLink>}
              </Icons>
              <Icons back={back}>
                <InstagramIcon
                  className="icon"
                  onClick={() => {
                    setShowI(!showI);
                    setShowL(false);
                    setShowT(false);
                    setShowF(false);
                  }}
                />
                {showI && <IconsLink back={back}>mariwan_akram</IconsLink>}
              </Icons>
              <Icons back={back}>
                <LinkedInIcon
                  className="icon"
                  onClick={() => {
                    setShowL(!showL);
                    setShowI(false);
                    setShowF(false);
                    setShowT(false);
                  }}
                />
                {showL && <IconsLink back={back}>Mariwan-Zia</IconsLink>}
              </Icons>
              <Icons back={back}>
                <TwitterIcon
                  className="icon"
                  onClick={() => {
                    setShowT(!showT);
                    setShowI(false);
                    setShowF(false);
                    setShowL(false);
                  }}
                />
                {showT && <IconsLink back={back}>Mariwan-A</IconsLink>}
              </Icons>
            </Cons>
            <Cons className="buttons">
              <ButtonCv onClick={() => setShow_Cv(true)} back={back}>
                Get My Cv
              </ButtonCv>
              <Button href="tel:07511828836" back={back}>
                Call Me
              </Button>
            </Cons>
          </BottomBot>
        </Bottom>
      </Wrap>
      {Show_Cv && <CvCloseBack onClick={() => setShow_Cv(false)} />}
      {Show_Cv && <ShowCv Show_Cv={Show_Cv} />}
    </Container>
  );
};
export default Contact;
const Container = styled.div`
  overflow-x: hidden;
  width: 100%;

  height: 100%;
  z-index: 6;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;

  box-shadow:color: ${(props) =>
    props.back === "sun" && "0px 10px 19px 0px rgba(143, 166, 168, 0.25)"};
  ${Mobile({
    overflow: "hidden",
    borderRadius: 10,
  })}
`;
const Wrap = styled.div`
  background: ${(props) =>
    props.back === "sun" ? " rgb(239, 245, 248)" : "#12181e"};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  padding: 30px;
  border: 5px solid rgb(151, 151, 151, 0.1);
  ${Mobile({
    borderRadius: 10,
    border: "2px solid rgb(151, 151, 151, 0.1)",
    padding: 10,
  })}
`;
const Top = styled.div`
  flex: 1.3;
  width: 25%;
  // background: green;
  display: flex;

  justify-content: center;
  align-items: center;
  // background: white;
  overflow: hidden;
  object-fit: cover;
  ${Mobile({ flex: 2.8, width: "65%" })}
`;
const ImagePro = styled.img`
  width: 100%;
  border-radius: 50%;
  height: auto;
`;
const Bottom = styled.div`
  flex: 3;
  width: 100%;
  // background: red;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const TOPBOTTOM = styled.div`
  flex: 1.5;
  // background: rgb(151, 151, 151, 0.1);
  width: 70%;
  padding: 50px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  // background: gray;
  ${Mobile({ width: "100%", flex: 0.7, padding: "20px 5px", marginTop: 10 })}
`;
const EachCon = styled.div`
  flex: 1;
  width: 85%;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 40px;
  // background: red;
  .ic {
    font-size: 35px;

    color: ${(props) =>
      props.back === "sun" ? "#747474" : " rgba(228, 236, 240, 0.7)"};
    ${Mobile({ fontSize: 27 })}
  }
  ${Mobile({
    width: "100%",
    justifyContent: "flex-start",
    gap: 8,
    margin: 2,
    flex: 1.2,
  })}
`;
const Links = styled.a`
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 1.3px;

  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.6)"
      : " rgba(228, 236, 240, 0.7)"};
  text-decoration: none;
  ${Mobile({ fontSize: 16, letterSpacing: " 0.8px", fontWeight: 600 })}
`;

const BottomBot = styled.div`
  flex: 1.4;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Cons = styled.div`
  flex: 1;
  width: 100%;

  display: flex;
  gap: 40px;
  justify-content: center;
  align-items: center;

  &.buttons {
    // background: RED;
    ${Mobile({
      flex: 2,
      flexDirection: "column",
      gap: 5,
      margin: 5,
      justifyContent: "space-around",
    })}
  }
`;
const Icons = styled.div`
  display: flex;
  width: 260px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  gap: 10px;
  .icon {
    font-size: 35px;
    transition: all 0.6s;

    color: ${(props) =>
      props.back === "sun"
        ? "rgba(12, 12, 28, 0.4)"
        : " rgba(228, 236, 240, 0.3)"};
    cursor: pointer;
    &:hover {
      color: ${(props) =>
        props.back === "sun"
          ? "rgba(12, 12, 28, 0.6)"
          : " rgba(228, 236, 240, 0.5)"};
    }
  }
`;
const IconsLink = styled.p`
  font-size: 14px;
  font-weight: 400;

  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.4)"
      : " rgba(228, 236, 240, 0.5)"};
  ${Mobile({display:'none' })}
`;
const Button = styled.a`
  width: 40%;
  height: 60%;
  border: none;
  border-radius: 10px;

  background: ${(props) =>
    props.back === "sun" ? "rgb(12, 12, 28, 0.9)" : "#30b709"};

  color: ${(props) =>
    props.back === "sun" ? "  rgb(236, 242, 244)" : "rgba(244, 251, 255,1)"};

  // color: white;
  font-size: 20px;
  display: flex;

  justify-content: center;
  align-items: center;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.5s;
  &:hover {
    background: ${(props) =>
      props.back === "sun" ? "rgb(12, 12, 28)" : "34c40a"};

    color: ${(props) =>
      props.back === "sun" ? "white" : "rgba(244, 251, 255, 1)"};
  }
  ${Mobile({
    width: "100%",
    height: "38%",
    fontWeight: 500,
    borderRadius: 7,
    fontSize: 20,
    letterSpacing: 1.2,
    border: "1px solid rgba(143, 166, 168, 0.15)",
    boxShadow: "0px 3px 5px 0px rgba(143, 166, 168, 0.05)",
  })}
`;
const ButtonCv = styled.button`
  width: 40%;
  height: 60%;
  border: none;
  border-radius: 10px;

  background: ${(props) =>
    props.back === "sun" ? "rgb(239, 245, 248)" : "rgba(26, 32, 39,1)"};

  color: ${(props) =>
    props.back === "sun"
      ? "  rgb(12, 12, 28, 0.7)"
      : "rgba(244, 251, 255, 0.7)"};

  // color: white;
  font-size: 20px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid rgb(12, 12, 28, 0.6);
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    border: 3px solid rgb(12, 12, 28, 0.8);
    color: rgb(12, 12, 28, 0.9);
  }

  ${Mobile({
    width: "100%",
    height: "38%",
    borderRadius: 7,
    border: "1px solid rgba(143, 166, 168, 0.15)",
    fontSize: 18,
    letterSpacing: 1.2,
    boxShadow: "0px 3px 5px 0px rgba(143, 166, 168, 0.05)",
  })}
`;
////////////
const CvCloseBack = styled.div`
  width: 100%;
  height: 100%;
  z-index: 7;
  position: fixed;
  top: 0;
  background: rgba(239, 243, 245, 0.15);
  backdrop-filter: blur(10px);
`;
